import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';

import { IPoiPreviewView } from './interfaces';

import { useStyles } from './styles';

const PoiPreviewView = ({
  children,
  onClick,
  poiName,
  hideBackdrop = false,
  compact = false,
  maxWidth,
}: IPoiPreviewView) => {
  const classes = useStyles(compact, maxWidth);

  return (
    <Modal
      open={true}
      onClose={onClick}
      hideBackdrop={hideBackdrop}
      disableEnforceFocus={compact}
      disableAutoFocus={compact}
      sx={compact ? { pointerEvents: 'none' } : undefined}
    >
      <Box sx={{ ...classes.modal, ...(compact && { pointerEvents: 'auto' }) }}>
        <Box sx={classes.title}>
          <Box sx={classes.titleWrapper}>
            <SettingsIcon />
            <Typography sx={classes.titleName}>{poiName}</Typography>
          </Box>
          <IconButton onClick={onClick} sx={classes.titleButton}>
            <CloseIcon />
          </IconButton>
        </Box>
        {children}
      </Box>
    </Modal>
  );
};

export default PoiPreviewView;
